import React, { FC, ReactNode, useEffect } from 'react';
import styles from './index.module.scss';
import { BlockHeading } from 'src/shared/Blocks/Heading';
import { IGenericCat, TenderCatName } from 'src/models/procurements/Tender/types';
import { useTranslation } from 'react-i18next';
import { Translations } from 'src/lib/I18nService/types';
import { scrollToCat } from 'src/shared/TenderNav/Categories/helper';
import { useLocation } from 'react-router-dom';

interface IProps {
  cat?: IGenericCat;
  children: ReactNode;
}
export const TenderCat: FC<IProps> = ({ cat, children }) => {
  const { t: tenderT } = useTranslation(Translations.procurements);
  const { hash } = useLocation();

  useEffect(() => {
    if (cat) {
      if (hash.includes(cat.id)) {
        const currentOffset = document.getElementById('tender')?.scrollTop;
        const offset = document.getElementById(cat.id)?.offsetTop;
        if (offset && !currentOffset) scrollToCat(offset);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cat]);

  return (
    <article className={styles.cat} id={cat?.id ?? TenderCatName.Overview}>
      {cat && <BlockHeading icon={cat.icon} title={tenderT(cat.title)} />}
      <div className={styles.content}>{children}</div>
    </article>
  );
};

export default TenderCat;
